import { render } from "./ConfigurationInput.vue?vue&type=template&id=4d61b92a&scoped=true&ts=true"
import script from "./ConfigurationInput.vue?vue&type=script&lang=ts"
export * from "./ConfigurationInput.vue?vue&type=script&lang=ts"

import "./ConfigurationInput.vue?vue&type=style&index=0&id=4d61b92a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d61b92a"]])

export default __exports__